"use client";

import { cleanPayload, QueryOptionsInterface } from "@saas/shared/utils";

import { kratos, useRegistrationFormQuery } from "../..";

import { RegistrationFlow } from "@ory/client";
import { useMutation } from "@tanstack/react-query";
import { parsePhoneNumber } from "libphonenumber-js";

export type RegisterMutationPayload = {
  name: string;
  identifier: string;
  password: string;
  phone?: string;
  businessType?: string;
  businessName?: string;
  birthdate?: string;
};

export const useRegisterMutation = (
  redirect?: string,
  options?: QueryOptionsInterface<
    RegistrationFlow,
    RegistrationFlow,
    { id: string }
  >
) => {
  const { data: register, refetch } = useRegistrationFormQuery(
    options?.enabled,
    redirect,
    options?.onError
  );

  const registerMutation = useMutation(
    async (data: RegisterMutationPayload) => {
      if (!register) {
        await refetch();

        throw new Error("Data sudah tidak berlaku, harap kirim ulang.");
      }

      return kratos
        .updateRegistrationFlow({
          flow: register.id,
          updateRegistrationFlowBody: {
            csrf_token: register.csrfToken,
            method: register.method.value,
            password: data.password,
            traits: cleanPayload({
              name: data.name,
              email: data.identifier,
              phone: data.phone
                ? parsePhoneNumber(data.phone, "ID").number
                : undefined,
              birthdate: data.birthdate,
              business_type: data.businessType,
              business_name: data.businessName,
            }),
          },
        })
        .catch((error) => {
          throw error.response.data;
        });
    }
  );

  return {
    ...registerMutation,
    isReady: !!register,
  };
};

export default useRegisterMutation;
